export enum SearchSplitConfiguration {
  Vertical,
  Horizontal,
  HideDocument
}
